import ExportEntityPaywallButton from "components/actions/ExportEntityPaywallButton";
import { useSubscription } from "lib/hooks/subscription";
import { EventDataTypes } from "lib/tracking";
import { useNoticeExport } from "../../lib/hooks/api/notices/useNoticeExport";
import { useNotices } from "../../lib/hooks/api/notices/useNotices";
import { ExportButtonGraphql } from "../actions/ExportButtonGraphql";
import { toast } from "../ui/toast/Toast";
import { DEFAULT_PAGINATION } from "./NoticeTable";
import { convertNoticeFiltersToSearchRequest, NoticeFilters } from "./utils";

export function ExportNoticesButton({
  filters,
  selectedNotices,
  extraDropdownItems,
}: {
  filters: NoticeFilters;
  selectedNotices?: string[];
  extraDropdownItems?: React.ReactNode;
}) {
  // If data sources include BUYERS|SUPPLIERS, then this user is on either the Growth or Expert plan and is authorised to export notices.
  const subscription = useSubscription();
  const authorised = subscription.hasDataTypes("SUPPLIERS") && subscription.hasDataTypes("BUYERS");

  if (!authorised) {
    return <ExportEntityPaywallButton />;
  }

  return (
    <ExportNoticesButtonInternal
      filters={filters}
      selectedNotices={selectedNotices}
      extraDropdownItems={extraDropdownItems}
    />
  );
}

function ExportNoticesButtonInternal({
  filters,
  selectedNotices,
  extraDropdownItems,
}: {
  filters: NoticeFilters;
  selectedNotices?: string[];
  extraDropdownItems?: React.ReactNode;
}) {
  // TODO: Right now, when signals column is active. Two requests will be made to the server.
  // This query doesn't incluide signals calculation, but the other does
  const { data: noticeSearch, isLoading } = useNotices(
    convertNoticeFiltersToSearchRequest(filters, DEFAULT_PAGINATION),
    false,
  );

  const noticeExportMutation = useNoticeExport({
    onError: () => toast.error("Failed to start export. Please try again later."),
  });

  const totalResults =
    selectedNotices && selectedNotices.length > 0
      ? selectedNotices.length
      : noticeSearch?.pagingInfo.totalResults ?? 0;

  const noticeSearchRequest = convertNoticeFiltersToSearchRequest(filters, {
    current: 1,
    pageSize: totalResults + 1,
  });

  return (
    <ExportButtonGraphql
      isLoadingTotalResults={isLoading}
      totalResults={totalResults}
      exportMutation={noticeExportMutation}
      exportVariables={{
        filters: noticeSearchRequest,
        selectedNotices: { noticeIds: selectedNotices },
      }}
      exportDataType={EventDataTypes.record}
      extraDropdownItems={extraDropdownItems}
    />
  );
}
